const DB_ENGINE = process.env.DB_ENGINE?.toLowerCase();
const IS_POSTGRES = DB_ENGINE === 'postgres';

export const normalizeJsonField = <T = unknown>(value: T | string): T | undefined => {
    if (typeof value !== 'string') {
        return value as T;
    }

    try {
        return JSON.parse(value) as T;
    } catch {
        // If parsing fails, return undefined so callers can decide how to handle it.
        return undefined;
    }
};

export const normalizeJsonFieldForPostgres = <T = unknown>(value: T | string): T | string => {
  if (!IS_POSTGRES) {
    return value;
  }

  if (typeof value !== 'string') {
    return value as T;
  }

  try {
    return JSON.parse(value) as T;
  } catch {
    return value as string;
  }
};